import de from "date-fns/locale/de";
// eslint-disable-next-line no-restricted-imports -- We avoid importing these directly except for this file
import nb from "date-fns/locale/nb";
import nn from "date-fns/locale/nn";
import { EditorLocale } from "./utils";

export const dateFnsLocaleMap: Record<EditorLocale, Locale> = { nb, nn, de };
